import styled from 'styled-components'
import { Input, Checkbox as AntCheckbox } from 'antd'
import { Div, Input as InputTest } from 'konsys-ui'
import { theme, media } from '../../../../../styles/_variables'


export const Checkbox = styled(AntCheckbox)`
.ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.color.greenPrimary};
    border-color: ${theme.color.greenPrimary};
}
`

export const LabelAmount = styled.div`
  color: ${theme.color.offWhite};
  font-size: ${theme.fonts.size.subTitle};
  font-weight: ${theme.fonts.style.medium};
  display: flex;
  justify-content: center;
  algin-items: center;
`

export const DivAmount = styled.div`
  padding: 20px;
  background-color: ${theme.color.greenPrimary};
  border-radius: 6px;
`

export const SpanButton = styled.span`
  font-weight: ${theme.fonts.style.medium};
  font-size: ${theme.fonts.size.extraNormal};
`

export const DivCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center
`

export const InputAmount = styled(Input)`
  min-width: 160px;
  .ant-input {
    font-size: 30px;
    height: 40px;
    text-align: center;
    border-radius: 20px;
    margin-top: -5px;
    border: 0px !important;
    padding-left: 40px;
    padding-right: 40px !important;
  }
  .ant-input-suffix {
    font-size: 30px;
    color: ${theme.color.primaryColor};
  }
`

export const DivInput = styled(Div)`
  background-color: white;
  border-radius: 24px;
  div {
    display: flex;
    alginItems: center;
  }
  input {
    border: 0px !important;
    padding: 0px 0px 0px 40px !important;
    background-color: transparent;
  }
  input:focus, input.gDAGJy:hover {
    border: unset;
  }
  span {
    font-size: 30px;
    color: ${theme.color.primaryColor};
    padding: 0 8px;
  }
`

export const InputAmountTest = styled(InputTest)`
  min-width: 160px;
  text-align: center;
  font-size: 30px;
  padding-left: 32px !important;
  .ant-input {
    font-size: 30px;
    height: 40px;
    text-align: center;
    border-radius: 20px;
    margin-top: -5px;
    border: 0px !important;
    padding-left: 40px;
    padding-right: 40px !important;
  }
  .ant-input-suffix {
    font-size: 30px;
    color: ${theme.color.primaryColor};
  }
`

export const CheckboxLabel = styled.span`
  font-weight: ${theme.fonts.style.medium};
  font-size: 20px;
`

export const CheckboxSpan = styled.span`
  font-weight: ${theme.fonts.style.regular};
  font-size: ${theme.fonts.size.small};
  margin-left: 24px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`

export const MoreTextLabel = styled.p`
  font-weight: ${theme.fonts.style.bold};
  font-size: ${theme.fonts.size.normal};
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  margin-bottom: 0px;
  color: ${theme.color.fourthColor};
  ${media.mobileXL`
    font-size: ${theme.fonts.size.normal};
  `}
`

export const MoreText = styled.h4`
  font-weight: ${theme.fonts.style.regular};
  font-size: ${theme.fonts.size.normal};
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  margin-bottom: 0px;
  color: ${theme.color.fourthColor};
  ${media.mobileXL`
    font-size: ${theme.fonts.size.small};
  `}
  &:before {
    content: "- ";
  }
`

export const DescriptionContent = styled(Div)`
  font-weight: ${theme.fonts.style.regular};
  font-size: ${theme.fonts.size.normal};
  & > p {
    margin: 0px !important;
    font-family: 'printAble4u', sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: ${theme.fonts.style.regular};
    color: ${theme.color.fourthColor};
  }
`

export default LabelAmount



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/table-price/styled.js